import { render, staticRenderFns } from "./aylRing.vue?vue&type=template&id=668b7320&scoped=true"
import script from "./aylRing.vue?vue&type=script&lang=js"
export * from "./aylRing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b7320",
  null
  
)

export default component.exports